// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';

import { Form } from '../components';
import PaperLayout from '../../../components/PaperLayout/PaperLayout';

const RegisterPage = history => (
  <PaperLayout label={'REGISTER NEW ACCOUNT'}>
    <Form toCheckout={history.location.state ? history.location.state.checkout : false} />
  </PaperLayout>
);

export default RegisterPage;
